import { Box, Typography, Paper, Container } from "@mui/material";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";

export default function CheckArea() {
  return (
    <Box sx={{ bgcolor: "#fafafa", height: "100%" }}>
      <Container maxWidth="xl" disableGutters>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 3,
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            mb: 3,
          }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <Box
              sx={{
                bgcolor: "rgba(255,255,255,0.2)",
                p: 1.5,
                borderRadius: 2,
                display: "flex",
              }}
            >
              <VerifiedUserIcon sx={{ fontSize: 40 }} />
            </Box>
            <Box>
              <Typography variant="h4" fontWeight={700}>
                Verificación
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.9, mt: 0.5 }}>
                Módulo en desarrollo
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
